var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{key:_vm.syncKey,attrs:{"background":"","layout":_vm.layout,"page-sizes":_vm.pageSizes,"page-size":_vm.pageSize,"current-page":_vm.currentPage,"total":_vm.total},on:{"current-change":_vm.emitPage,"size-change":_vm.emitSize}})
}
var staticRenderFns = []

export { render, staticRenderFns }